/**
 * Bundle Builder — assets/bundle-builder.js
 */
(function () {
  'use strict';

  class BundleBuilder {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      this.min = parseInt(el.dataset.bundleMin, 10) || 2;
      this.max = parseInt(el.dataset.bundleMax, 10) || 4;
      try { this.tiers = JSON.parse(el.dataset.discountTiers || '[]'); }
      catch (e) { this.tiers = [[2,5,20],[3,10,20],[4,15,20]]; }
      this.bundle = [];
      this.purchaseType = 'subscription';
      this._bindElements();
      this._bindEvents();
      this._render();
    }

    _bindElements() {
      this.cards           = [...this.el.querySelectorAll('.bundle-card')];
      this.slots           = [...this.el.querySelectorAll('.bundle-slot')];
      this.progressSteps   = [...this.el.querySelectorAll('.bundle-progress__step')];
      this.progressText    = this.el.querySelector('[data-progress-text]');
      this.savingsBadge    = this.el.querySelector('[data-savings-badge]');
      this.savingsPct      = this.el.querySelector('[data-savings-pct]');
      this.comparePriceSub = this.el.querySelector('[data-compare-price-sub]');
      this.finalPriceSub   = this.el.querySelector('[data-final-price-sub]');
      this.comparePriceOt  = this.el.querySelector('[data-compare-price-ot]');
      this.finalPriceOt    = this.el.querySelector('[data-final-price-ot]');
      this.subSavingsBadge = this.el.querySelector('[data-sub-savings-badge]');
      this.otSavingsBadge  = this.el.querySelector('[data-ot-savings-badge]');
      this.addToCartBtn    = this.el.querySelector('[data-add-to-cart]');
      this.ctaPrice        = this.el.querySelector('[data-cta-price]');
    }

    _bindEvents() {
      // Add / Remove
      this.el.addEventListener('click', (e) => {
        const card = e.target.closest('.bundle-card');
        if (card) {
          if (e.target.closest('[data-action="add"]'))    this._addProduct(card);
          if (e.target.closest('[data-action="remove"]')) this._removeProduct(card.dataset.productId);
        }
        const slotRemoveBtn = e.target.closest('[data-slot-remove]');
        if (slotRemoveBtn) {
          const idx = parseInt(slotRemoveBtn.dataset.slotRemove, 10) - 1;
          if (this.bundle[idx]) this._removeProduct(this.bundle[idx].productId);
        }
      });

      // Variant change
      this.el.addEventListener('change', (e) => {
        const select = e.target.closest('[data-variant-select]');
        if (!select) return;
        const card = select.closest('.bundle-card');
        if (!card) return;
        const opt = select.options[select.selectedIndex];

        card.dataset.variantId      = opt.value;
        card.dataset.productPrice   = opt.dataset.price;
        card.dataset.subVariantId   = opt.dataset.subVariantId   || '';
        card.dataset.subPrice       = opt.dataset.subPrice       || '';
        card.dataset.subSellingPlan = opt.dataset.subSellingPlan || '';
        card.dataset.subCustomPrice = opt.dataset.subCustomPrice || '';
        card.dataset.subStrikePrice = opt.dataset.subStrikePrice || '';
        card.dataset.subSavePct     = opt.dataset.subSavePct     || '';
        card.dataset.otpCustomPrice = opt.dataset.otpCustomPrice || '';
        card.dataset.otpStrikePrice = opt.dataset.otpStrikePrice || '';
        card.dataset.selectedPacks  = opt.dataset.packs          || '0';

        const pid = card.dataset.productId;
        const entry = this.bundle.find(b => b.productId === pid);
        if (entry) {
          entry.variantId      = opt.value;
          entry.price          = parseInt(opt.dataset.price, 10);
          entry.meta           = opt.dataset.title        || '';
          entry.subVariantId   = opt.dataset.subVariantId   || null;
          entry.subPrice       = opt.dataset.subPrice ? parseInt(opt.dataset.subPrice, 10) : null;
          entry.subSellingPlan = opt.dataset.subSellingPlan  || null;
          entry.subCustomPrice = opt.dataset.subCustomPrice  || null;
          entry.subStrikePrice = opt.dataset.subStrikePrice  || null;
          entry.subSavePct     = opt.dataset.subSavePct      || null;
          entry.otpCustomPrice = opt.dataset.otpCustomPrice  || null;
          entry.otpStrikePrice = opt.dataset.otpStrikePrice  || null;
          entry.selectedPacks  = parseInt(opt.dataset.packs  || '0', 10);
          this._render();
        }
      });

      // Purchase type toggle
      this.el.addEventListener('change', (e) => {
        if (e.target.name === `purchase_type_${this.sectionId}`) {
          this.purchaseType = e.target.value;
          this._render();
        }
      });

      // Filter tabs
      this.el.addEventListener('click', (e) => {
        const filterBtn = e.target.closest('.bundle-filter');
        if (!filterBtn) return;
        const filter = filterBtn.dataset.filter;
        this.el.querySelectorAll('.bundle-filter').forEach(btn => {
          btn.classList.toggle('bundle-filter--active', btn === filterBtn);
          btn.setAttribute('aria-selected', btn === filterBtn ? 'true' : 'false');
        });
        this.cards.forEach(card => {
          const cat = card.dataset.category || '';
          card.toggleAttribute('data-filter-hidden', filter !== 'all' && cat !== filter);
        });
      });

      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', () => this._addToCart());
      }
    }

    // ── Core actions ─────────────────────────────────────────
    _addProduct(card) {
      const pid = card.dataset.productId;
      if (this.bundle.length >= this.max) return;
      if (this.bundle.find(b => b.productId === pid)) return;

      const variantSelect = card.querySelector('[data-variant-select]');
      let variantId      = card.dataset.variantId;
      let subVariantId   = card.dataset.subVariantId   || null;
      let subPrice       = card.dataset.subPrice ? parseInt(card.dataset.subPrice, 10) : null;
      let subSellingPlan = card.dataset.subSellingPlan  || null;
      let subCustomPrice = card.dataset.subCustomPrice  || null;
      let subStrikePrice = card.dataset.subStrikePrice  || null;
      let subSavePct     = card.dataset.subSavePct      || null;
      let otpCustomPrice = card.dataset.otpCustomPrice  || null;
      let otpStrikePrice = card.dataset.otpStrikePrice  || null;
      let selectedPacks  = parseInt(card.dataset.selectedPacks || '0', 10);
      let meta           = '';

      if (variantSelect) {
        const opt = variantSelect.options[variantSelect.selectedIndex];
        if (opt) {
          variantId      = opt.value;
          meta           = opt.dataset.title       || '';
          subVariantId   = opt.dataset.subVariantId   || subVariantId;
          subPrice       = opt.dataset.subPrice ? parseInt(opt.dataset.subPrice, 10) : subPrice;
          subSellingPlan = opt.dataset.subSellingPlan  || subSellingPlan;
          subCustomPrice = opt.dataset.subCustomPrice  || subCustomPrice;
          subStrikePrice = opt.dataset.subStrikePrice  || subStrikePrice;
          subSavePct     = opt.dataset.subSavePct      || subSavePct;
          otpCustomPrice = opt.dataset.otpCustomPrice  || otpCustomPrice;
          otpStrikePrice = opt.dataset.otpStrikePrice  || otpStrikePrice;
          selectedPacks  = parseInt(opt.dataset.packs  || selectedPacks, 10);
        }
      }

      this.bundle.push({
        productId:      pid,
        variantId:      variantId,
        title:          card.dataset.productTitle,
        price:          parseInt(card.dataset.productPrice, 10),
        image:          card.dataset.productImage,
        meta:           meta,
        subVariantId:   subVariantId,
        subProductId:   card.dataset.subProductId || null,
        subPrice:       subPrice,
        subSellingPlan: subSellingPlan,
        subCustomPrice: subCustomPrice,  // 3-pack sub price e.g. $15.30
        subStrikePrice: subStrikePrice,  // 3-pack strikethrough e.g. $18.00
        subSavePct:     subSavePct,      // base save % e.g. 15
        otpCustomPrice: otpCustomPrice,  // 3-pack otp custom price if set
        otpStrikePrice: otpStrikePrice,
        selectedPacks:  selectedPacks,   // e.g. 3 for a 3-Pack variant
      });

      this._render();
    }

    _removeProduct(pid) {
      this.bundle = this.bundle.filter(b => b.productId !== pid);
      this._render();
    }

    // ── Render ───────────────────────────────────────────────
    _render() {
      this._updateCards();
      this._updateProgress();
      this._updateSlots();
      this._updatePricing();
      this._updateCta();
    }

    _updateCards() {
      const addedIds = new Set(this.bundle.map(b => b.productId));
      this.cards.forEach(card => {
        const pid      = card.dataset.productId;
        const inBundle = addedIds.has(pid);
        const isFull   = this.bundle.length >= this.max && !inBundle;
        card.classList.toggle('bundle-card--in-bundle', inBundle);
        const addBtn    = card.querySelector('[data-action="add"]');
        const removeBtn = card.querySelector('[data-action="remove"]');
        if (addBtn)    { addBtn.style.display = inBundle ? 'none' : ''; addBtn.disabled = isFull; addBtn.style.opacity = isFull ? '0.4' : ''; }
        if (removeBtn) { removeBtn.style.display = inBundle ? '' : 'none'; }
      });
    }

    _updateProgress() {
      const count = this.bundle.length;
      this.progressSteps.forEach((step, i) => {
        step.classList.toggle('bundle-progress__step--filled', i < count);
        step.classList.toggle('bundle-progress__step--active', i === count && count < this.max);
        const line = step.querySelector('.bundle-progress__line');
        if (line) line.style.background = i < count ? 'var(--bb-blue)' : '';
      });
      if (this.progressText) {
        const tier     = this._getCurrentTier();
        const nextTier = this._getNextTier();
        if (count === 0) {
          this.progressText.textContent = `Add ${this.min} products to start saving`;
        } else if (nextTier) {
          const needed = nextTier[0] - count;
          this.progressText.textContent = `Add ${needed} more to unlock more savings`;
        } else if (tier) {
          this.progressText.textContent = `🎉 You're saving on your bundle!`;
        } else {
          this.progressText.textContent = `${count} of ${this.max} products added`;
        }
      }
      const tier = this._getCurrentTier();
      if (this.savingsBadge) this.savingsBadge.style.display = tier ? '' : 'none';
    }

    _updateSlots() {
      this.slots.forEach((slot, i) => {
        const entry  = this.bundle[i];
        const filled = !!entry;
        slot.classList.toggle('bundle-slot--filled', filled);
        slot.classList.toggle('bundle-slot--empty', !filled);
        const placeholder = slot.querySelector('.bundle-slot__placeholder');
        const productDiv  = slot.querySelector('.bundle-slot__product');
        const removeBtn   = slot.querySelector('.bundle-slot__remove');
        if (filled) {
          if (placeholder) placeholder.style.display = 'none';
          if (productDiv) {
            productDiv.style.display = 'flex';
            const img  = productDiv.querySelector('.bundle-slot__img');
            const name = productDiv.querySelector('.bundle-slot__name');
            const meta = productDiv.querySelector('.bundle-slot__meta');
            if (img)  { img.src = entry.image; img.alt = entry.title; }
            if (name) name.textContent = entry.title;
            if (meta) meta.textContent = entry.meta || '';
          }
          if (removeBtn) removeBtn.style.display = '';
        } else {
          if (placeholder) placeholder.style.display = '';
          if (productDiv)  productDiv.style.display  = 'none';
          if (removeBtn)   removeBtn.style.display   = 'none';
        }
      });
    }

    _updatePricing() {
      const isSub = this.purchaseType === 'subscription';

      if (!this.bundle.length) {
        [this.comparePriceSub, this.comparePriceOt].forEach(el => { if (el) el.textContent = ''; });
        [this.finalPriceSub, this.finalPriceOt].forEach(el => { if (el) el.textContent = '—'; });
        if (this.ctaPrice) this.ctaPrice.textContent = '';
        return;
      }

      // ── Total pack count across all bundle items ──────────
      // Each item's selectedPacks comes from parsing the variant option
      // e.g. "Grapefruit Zest / 3-Pack" → selectedPacks = 3
      const totalPacks = this.bundle.reduce((sum, b) => sum + (b.selectedPacks || 0), 0);

      // ── Bundle bonus discount based on total packs ────────
      // Subscription: base price from subCustomPrice metafield + bonus % on top
      //   < 6 packs:  +0%  (just the base sub price, e.g. 3-pack = $15.30)
      //   6 packs:    +3%  (2× 3-packs → show 3% more off the sub base)
      //   9 packs:    +6%
      //   12 packs:   +9%
      //
      // OTP: base price from variant price + bundle discount
      //   < 6 packs:  0% off  (no bundle discount)
      //   6 packs:    5% off
      //   9 packs:    8% off
      //   12 packs:   10% off
      let subBundleBonus   = 0;
      let otpBundleDiscount = 0;
      if      (totalPacks >= 12) { subBundleBonus = 9;  otpBundleDiscount = 10; }
      else if (totalPacks >= 9)  { subBundleBonus = 6;  otpBundleDiscount = 8;  }
      else if (totalPacks >= 6)  { subBundleBonus = 3;  otpBundleDiscount = 5;  }

      const parseDollars = (v) => v ? Math.round(parseFloat(v) * 100) : null;

      // ── Sum prices across all bundle items ────────────────
      let subBase  = 0;  // sum of subCustomPrice (base sub price per item)
      let subStrike = 0; // sum of subStrikePrice (full price before Loop discount)
      let subSavePct = 0, subSavePctCount = 0;
      let otpBase  = 0;  // sum of OTP prices per item
      let otpStrike = 0; // sum of OTP strikethrough prices

      this.bundle.forEach(b => {
        // Sub: use subCustomPrice metafield (e.g. $15.30 for 3-pack)
        // Fall back to subPrice (variant price in cents) then OTP price
        const subC = parseDollars(b.subCustomPrice);
        const subS = parseDollars(b.subStrikePrice);
        const subFallback = b.subPrice || b.price;
        subBase   += subC || subFallback;
        subStrike += subS || subC || subFallback;
        if (b.subSavePct) { subSavePct += parseFloat(b.subSavePct); subSavePctCount++; }

        // OTP: use price (in cents) as the base. otpCustomPrice if set.
        const otpC = parseDollars(b.otpCustomPrice);
        const otpS = parseDollars(b.otpStrikePrice);
        otpBase   += otpC || b.price;
        otpStrike += otpS || otpC || b.price;
      });

      // ── Apply bundle bonus on top of base prices ──────────
      // Sub final = base sub price × (1 - bundleBonus%)
      // e.g. $15.30 base × 0.97 = $14.84 per item, × 2 items = $29.68... 
      // wait — we want $24.23 for 2×3-packs. That means the WHOLE bundle
      // gets the same price as a 6-pack. So the bonus applies to the total.
      const subFinal = Math.round(subBase * (1 - subBundleBonus / 100));
      const otpFinal = Math.round(otpBase * (1 - otpBundleDiscount / 100));

      // Strikethrough: show subStrike (full price) when there's any saving
      // For OTP: show otpBase as strikethrough when bundle discount applies
      const subShowStrike = subStrike > subFinal;
      const otpShowStrike = otpBundleDiscount > 0 && otpBase > otpFinal;

      // ── Savings % badges ──────────────────────────────────
      // Sub total savings = base variant save% + bundle bonus
      const baseSubSavePct  = subSavePctCount > 0 ? Math.round(subSavePct / subSavePctCount) : 0;
      const totalSubSavePct = baseSubSavePct + subBundleBonus;
      const subSavingsLabel = totalSubSavePct > 0 ? `${totalSubSavePct}% TOTAL SAVINGS` : 'WITH AUTOSHIP';
      const otpSavingsLabel = otpBundleDiscount > 0 ? `${otpBundleDiscount}% TOTAL SAVINGS` : '';

      if (this.subSavingsBadge) this.subSavingsBadge.textContent = subSavingsLabel;
      if (this.otSavingsBadge) {
        this.otSavingsBadge.textContent   = otpSavingsLabel;
        this.otSavingsBadge.style.display = otpSavingsLabel ? '' : 'none';
      }

      // Sub prices
      if (this.comparePriceSub) this.comparePriceSub.textContent = subShowStrike ? this._money(subStrike) : '';
      if (this.finalPriceSub)   this.finalPriceSub.textContent   = this._money(subFinal);

      // OTP prices
      if (this.comparePriceOt) this.comparePriceOt.textContent  = otpShowStrike ? this._money(otpBase) : '';
      if (this.finalPriceOt)   this.finalPriceOt.textContent    = this._money(otpFinal);

      // CTA price
      if (this.ctaPrice) this.ctaPrice.textContent = this._money(isSub ? subFinal : otpFinal);

      // Top savings badge in sidebar header
      const tier = this._getCurrentTier();
      if (this.savingsBadge) {
        this.savingsBadge.style.display = tier ? '' : 'none';
        if (tier && this.savingsPct) {
          this.savingsPct.textContent = totalSubSavePct > 0 ? totalSubSavePct + '%' : tier[1] + '%';
        }
      }
    }

    _updateCta() {
      const ready = this.bundle.length >= this.min;
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = !ready;
        this.addToCartBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }
    }

    // ── Add to cart ──────────────────────────────────────────
    async _addToCart() {
      if (this.bundle.length < this.min) return;

      const isSub = this.purchaseType === 'subscription';

      // Add exactly the variant the customer selected — no swapping.
      // SAVEMORE + Loop apply the real discounts at checkout.
      const items = this.bundle.map(b => {
        const useSubVariant = isSub && b.subVariantId;
        const variantId     = useSubVariant ? b.subVariantId   : b.variantId;
        const sellingPlan   = useSubVariant ? b.subSellingPlan : null;

        const item = {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            _bundle:        this.sectionId,
            _purchase_type: this.purchaseType,
            _display_title: b.title,
          },
        };
        if (useSubVariant && sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
        return item;
      });

      if (isSub) {
        const missing = this.bundle.filter(b => !b.subVariantId).map(b => b.title);
        if (missing.length) console.warn('[BundleBuilder] No sub variant mapped for:', missing);
      }

      this.addToCartBtn.disabled = true;
      this.addToCartBtn.querySelector('.bundle-cta__label').textContent = 'Adding…';

      try {
        const cartSectionIds = this._detectCartSectionIds();
        const body = { items };
        if (cartSectionIds.length) { body.sections = cartSectionIds; body.sections_url = window.location.pathname; }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error('Cart error');
        const data = await res.json();
        if (data.sections) this._patchCartSections(data.sections);
        this._openCartDrawer();

        this.addToCartBtn.querySelector('.bundle-cta__label').textContent = '✓ Added!';
        setTimeout(() => {
          this.addToCartBtn.querySelector('.bundle-cta__label').textContent = 'ADD TO CART';
          this.addToCartBtn.disabled = false;
        }, 1800);
      } catch (err) {
        console.error('[BundleBuilder] Add to cart failed:', err);
        this.addToCartBtn.querySelector('.bundle-cta__label').textContent = 'Error — Try Again';
        this.addToCartBtn.disabled = false;
      }
    }

    // ── Cart drawer helpers ──────────────────────────────────
    _detectCartSectionIds() {
      const selectors = [
        '[id*="cart-drawer"][data-section-id]','[id*="CartDrawer"][data-section-id]',
        'cart-drawer[data-section-id]','[data-section-type="cart-drawer"]',
        '#shopify-section-cart-drawer','#shopify-section-cart',
      ];
      const ids = new Set();
      selectors.forEach(sel => document.querySelectorAll(sel).forEach(el => {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
        const m = el.id && el.id.match(/^shopify-section-(.+)$/);
        if (m) ids.add(m[1]);
      }));
      if (!ids.size) ['cart-drawer','cart','ajax-cart','mini-cart'].forEach(id => ids.add(id));
      return [...ids];
    }

    _patchCartSections(sections) {
      Object.entries(sections).forEach(([sectionId, html]) => {
        const wrapper = document.getElementById(`shopify-section-${sectionId}`);
        if (!wrapper) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const inner = tmp.firstElementChild;
        if (inner) wrapper.innerHTML = inner.innerHTML;
      });
    }

    _openCartDrawer() {
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.open === 'function') { drawerEl.open(); return; }
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') { window.cartDrawer.open(); return; }
      if (window.CartDrawer && typeof window.CartDrawer.open === 'function') { window.CartDrawer.open(); return; }
      if (window.theme && window.theme.cartDrawer) {
        const cd = window.theme.cartDrawer;
        if (typeof cd.open === 'function') { cd.open(); return; }
        if (typeof cd.show === 'function') { cd.show(); return; }
      }
      if (window.Drawer) {
        const d = document.querySelector('[data-drawer="cart-drawer"]');
        if (d) { window.Drawer.open(d); return; }
      }
      const ariaTargets = [
        document.getElementById('cart-drawer'),
        document.querySelector('[data-cart-drawer]'),
        document.querySelector('[data-drawer="cart"]'),
        document.querySelector('.cart-drawer'),
        document.querySelector('.CartDrawer'),
        document.querySelector('.js-cart-drawer'),
        document.querySelector('#CartDrawer'),
      ].filter(Boolean);
      ariaTargets.forEach(el => {
        el.removeAttribute('aria-hidden');
        el.setAttribute('aria-expanded', 'true');
        el.classList.remove('is-hidden','hidden','drawer--is-closed','cart-drawer--closed');
        el.classList.add('is-active','is-open','drawer--is-open','cart-drawer--open','active');
      });
      const overlay = document.querySelector('.drawer-overlay,.cart-overlay,.js-overlay,[data-overlay],.overlay');
      if (overlay) { overlay.classList.add('is-active','is-visible','active'); overlay.removeAttribute('hidden'); }
      document.body.classList.add('drawer-open','cart-open','overflow-hidden');
      if (!ariaTargets.length) {
        const cartBtn = document.querySelector(
          '[data-cart-toggle],[data-cart-icon-bubble],.cart-icon-bubble,[data-open="cart-drawer"],[aria-controls="cart-drawer"],.js-cart-toggle'
        );
        if (cartBtn) cartBtn.click();
      }
      document.dispatchEvent(new CustomEvent('cart:open',       { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cartDrawer:open', { bubbles: true }));
    }

    // ── Helpers ──────────────────────────────────────────────
    _getCurrentTier() {
      const count = this.bundle.length;
      return [...this.tiers].reverse().find(t => count >= t[0]) || null;
    }
    _getNextTier() {
      const count = this.bundle.length;
      return this.tiers.find(t => t[0] > count) || null;
    }
    _money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.bundle-builder').forEach(el => {
      if (!el._bundleBuilder) el._bundleBuilder = new BundleBuilder(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('.bundle-builder');
    if (el) el._bundleBuilder = new BundleBuilder(el);
  });
})();